import * as React from 'react'

import { BookkeepersCompanyIncidenceMessageStatFragment } from 'generated/resources/graphql'

const IncidenceMessageStatsContext = React.createContext<
  BookkeepersCompanyIncidenceMessageStatFragment[] | null
>(null)
export const IncidenceMessageStatsProvider = IncidenceMessageStatsContext.Provider

export const useIncidenceMessageStats = (): BookkeepersCompanyIncidenceMessageStatFragment[] => {
  const values = React.useContext(IncidenceMessageStatsContext)

  if (!values) {
    throw new Error('useIncidenceMessageStats must be used within an IncidenceMessageStatsProvider')
  }

  return values
}
